<router-outlet />
<ngx-ui-loader fgsColor="#000"></ngx-ui-loader>
